export const POLLING_INTERVAL_MESSAGES = 8000;
export const THREAD_LIMIT = 100;
export const MESSAGE_LIMIT = 25;
export const POLLING_INTERVAL_THREADS = 20000;
